// Dual-handle price range slider
function initPriceRangeSliders() {
    document.querySelectorAll('.facets-new__range-wrapper').forEach(function (wrapper) {
        // Avoid double-binding on re-render
        if (wrapper.dataset.sliderInit) return;
        wrapper.dataset.sliderInit = '1';

        const groupBody = wrapper.closest('.facets-new__group-body');
        if (!groupBody) return;
        const priceRange = groupBody.querySelector('price-range');
        if (!priceRange) return;

        const minRange = wrapper.querySelector('.facets-new__range-input--min');
        const maxRange = wrapper.querySelector('.facets-new__range-input--max');
        const numberInputs = priceRange.querySelectorAll('input[type="number"]');
        if (!minRange || !maxRange || numberInputs.length < 2) return;

        const minNumber = numberInputs[0];
        const maxNumber = numberInputs[1];
        const track = wrapper.querySelector('.facets-new__range-track');
        const rangeMax = parseFloat(maxRange.max) || 1;

        function updateFill() {
            const lo = parseFloat(minRange.value) || 0;
            const hi = parseFloat(maxRange.value) || rangeMax;
            const loPct = (lo / rangeMax * 100).toFixed(2) + '%';
            const hiPct = (hi / rangeMax * 100).toFixed(2) + '%';
            track.style.background = 'linear-gradient(to right, #E5E3D4 ' + loPct + ', #5FCE36 ' + loPct + ', #5FCE36 ' + hiPct + ', #E5E3D4 ' + hiPct + ')';
        }

        // Pre-initialize data-max/data-min so PriceRange.adjustToValidValues
        // never sees an unset attribute (which resolves to 0 and clamps the value).
        minNumber.setAttribute('data-max', rangeMax);
        maxNumber.setAttribute('data-min', 0);

        // Init slider positions from number inputs (already whole numbers from Liquid)
        minRange.value = minNumber.value !== '' ? minNumber.value : 0;
        maxRange.value = maxNumber.value !== '' ? maxNumber.value : rangeMax;
        updateFill();

        minRange.addEventListener('input', function () {
            if (parseFloat(minRange.value) > parseFloat(maxRange.value)) {
                minRange.value = maxRange.value;
            }
            minNumber.value = Math.round(parseFloat(minRange.value));
            // No dispatchEvent — the range input's 'input' event already bubbles
            // to the form and triggers debouncedOnSubmit.
            updateFill();
            minRange.style.zIndex = 5;
            maxRange.style.zIndex = 4;
        });

        maxRange.addEventListener('input', function () {
            if (parseFloat(maxRange.value) < parseFloat(minRange.value)) {
                maxRange.value = minRange.value;
            }
            maxNumber.value = Math.round(parseFloat(maxRange.value));
            updateFill();
            maxRange.style.zIndex = 5;
            minRange.style.zIndex = 4;
        });

        // Sync sliders when number inputs are edited manually
        minNumber.addEventListener('change', function () {
            if (minNumber.value !== '') minRange.value = Math.round(parseFloat(minNumber.value));
            updateFill();
        });

        maxNumber.addEventListener('change', function () {
            if (maxNumber.value !== '') maxRange.value = Math.round(parseFloat(maxNumber.value));
            updateFill();
        });
    });
}

document.addEventListener('DOMContentLoaded', initPriceRangeSliders);
document.addEventListener('facets:rendered', initPriceRangeSliders);

// Product card variant overflow (+N button)
(function () {
    function initVariantOverflow(container) {
        const items = Array.from(container.querySelectorAll('.variant-option'));
        const btn = container.querySelector('.product-card__variants-more');
        if (!btn || items.length < 2) return;

        const firstTop = Math.round(items[0].getBoundingClientRect().top);
        let cutIndex = -1;
        for (let i = 1; i < items.length; i++) {
            if (Math.round(items[i].getBoundingClientRect().top) > firstTop) {
                cutIndex = i;
                break;
            }
        }
        if (cutIndex < 0) return;

        if (cutIndex > 0) cutIndex = Math.max(1, cutIndex - 1);

        const toHide = items.slice(cutIndex);
        toHide.forEach(function (item) { item.hidden = true; });
        btn.textContent = '+' + toHide.length;
        btn.hidden = false;

        btn.addEventListener('click', function () {
            toHide.forEach(function (item) { item.hidden = false; });
            btn.hidden = true;
        }, { once: true });
    }

    function initAll() {
        document.querySelectorAll('.product-card__variants').forEach(initVariantOverflow);
    }

    function run() {
        requestAnimationFrame(function () { requestAnimationFrame(initAll); });
    }

    if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(run);
    } else if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', run);
    } else {
        run();
    }

    document.addEventListener('facets:rendered', run);
    // Cards that arrive after load (product recommendations, and anything else that
    // fetches a section) dispatch this once their markup is in the DOM.
    document.addEventListener('product-cards:rendered', run);
})();

// Product card image skeleton loader
(function () {
    function markLoaded(img) {
        img.classList.add('img-loaded');
        const area = img.closest('.product-card__image-area');
        if (area) area.classList.add('img-loaded');
    }

    function initImageSkeleton(root) {
        (root || document).querySelectorAll('.product-card__image').forEach(function (img) {
            if (img.complete && img.naturalWidth > 0) {
                markLoaded(img);
            } else {
                img.addEventListener('load', function () { markLoaded(img); }, { once: true });
                img.addEventListener('error', function () { markLoaded(img); }, { once: true });
            }
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { initImageSkeleton(); });
    } else {
        initImageSkeleton();
    }

    document.addEventListener('facets:rendered', function () { initImageSkeleton(); });
    // Same as above — the image starts at opacity 0 and only this pass reveals it, so a card
    // inserted after load stays blank until its section says so.
    document.addEventListener('product-cards:rendered', function () { initImageSkeleton(); });
})();

// Product card variant switching
document.addEventListener('click', function (e) {
    const option = e.target.closest('.variant-option[data-variant-id]');
    if (!option) return;

    const card = option.closest('.product-card');
    if (!card) return;

    const variantId = option.dataset.variantId;

    card.querySelectorAll('.variant-card').forEach(function (vc) {
        vc.classList.remove('active');
    });

    const target = card.querySelector('.variant-card[data-variant-id="' + variantId + '"]');
    if (target) target.classList.add('active');
});

// Smooth <details> open/close — opt-in via `data-smooth` on the <details> element.
//
// Native <details> snaps open with no in-between state, so this animates the element's own height
// between its collapsed and expanded sizes and flips `open` at the right end: BEFORE an open (so the
// content is laid out and measurable) and AFTER a close (so it stays visible while it collapses).
//
// Both heights are measured off the real element by toggling `open` and reading it back. Layout reads
// are synchronous and nothing paints mid-handler, so the temporary toggle is invisible — and reading
// the <details> rather than summing children keeps its own borders/padding in the number.
//
// Delegated from the document, so accordions inserted later (variant refresh, section re-render) need
// no re-init, and no CSS is required in the consuming section.
(function () {
    const DURATION = 260;
    const EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';

    // `fill: 'forwards'` holds the end height until settle() cancels it, so nothing snaps back for a
    // frame between the animation finishing and `open`/inline styles catching up.
    //
    // settle() runs once, off whichever of two triggers fires first. The `finished` promise is the
    // normal path; the timer is the safety net, because a document whose timeline is paused (a
    // backgrounded tab) never delivers the finish notification — and without it a details clicked
    // just before the tab was hidden would stay latched at `animating` and stop responding.
    // `direction` ('open' | 'close') is published on data-animating so CSS can tell the two apart:
    // `open` stays true for the whole of a close, so a chevron keyed on [open] alone would snap back
    // at the very end instead of unwinding with the collapse.
    function animate(details, from, to, direction, onEnd) {
        details.style.overflow = 'hidden';
        details.dataset.animating = direction;

        const run = details.animate(
            { height: [from + 'px', to + 'px'] },
            { duration: DURATION, easing: EASING, fill: 'forwards' }
        );

        let settled = false;
        const settle = function () {
            if (settled) return;
            settled = true;
            onEnd();
            details.style.overflow = '';
            details.dataset.animating = '';
            run.cancel(); // release the held height back to the natural one
        };
        run.finished.then(settle, settle);
        setTimeout(settle, DURATION + 100);
    }

    // Exclusive groups: inside a container marked [data-accordion-single], opening one row collapses
    // every other open row. Nested groups are respected — a row only closes rows whose OWN nearest
    // group is the same container, so an inner accordion never collapses its outer one.
    //
    // `instant` skips the animation (reduced motion, or a row already mid-animation, whose height
    // reads would be transient).
    function collapseSiblings(details, instant) {
        const group = details.closest('[data-accordion-single]');
        if (!group) return;

        group.querySelectorAll('details[data-smooth][open]').forEach(function (other) {
            if (other === details || other.closest('[data-accordion-single]') !== group) return;
            if (instant || other.dataset.animating) {
                other.open = false;
                return;
            }
            const from = other.offsetHeight;
            other.open = false;
            const to = other.offsetHeight;
            other.open = true; // keep the content on screen while it collapses
            animate(other, from, to, 'close', function () { other.open = false; });
        });
    }

    document.addEventListener('click', function (e) {
        const summary = e.target.closest('details[data-smooth] > summary');
        if (!summary) return;

        const details = summary.parentElement;
        // A click landing mid-animation would measure a transient height; let the current one finish.
        if (details.dataset.animating) {
            e.preventDefault();
            return;
        }
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            // Native toggle handles the row itself; the group rule still has to be applied.
            if (!details.open) collapseSiblings(details, true);
            return;
        }

        e.preventDefault();
        const wasOpen = details.open;
        const before = details.offsetHeight;
        details.open = !wasOpen;
        const after = details.offsetHeight;

        // Before the open animation starts, so both run over the same frames.
        if (!wasOpen) collapseSiblings(details, false);

        if (wasOpen) {
            details.open = true; // keep the content on screen while it collapses
            animate(details, before, after, 'close', function () { details.open = false; });
        } else {
            animate(details, before, after, 'open', function () {});
        }
    });
})();